// Shared Escape-to-clear behavior for search/filter text inputs, per
// ~/.claude/skills/ui-ux-standard/references/STANDARD.md.
import type { KeyboardEvent } from "react";

export function clearOnEscape(value: string, setValue: (v: string) => void) {
  return (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape" && value) {
      e.stopPropagation();
      setValue("");
    }
  };
}
